import '/assets/scripting/lib/jquery-fancybox/js/jquery.fancybox.min.js?v=2';
import { loadCss } from 'utils';

loadCss({
    url: config.assetsUrl + '/scripting/lib/jquery-fancybox/css/jquery.fancybox.css'
});